<template>
  <div class="mt__main">
    <div class="mt__banner"></div>
    <div class="mt__center">
      <div class="mt__content--main">
        <div>
          <el-tabs
            @tab-click="tabClick"
            v-model="activeName"
            tab-position="left"
            :class="{ mt__sticky: sticky }"
          >
            <el-tab-pane label="招聘流程" name="process"></el-tab-pane>
            <el-tab-pane label="薪酬福利" name="compensation"></el-tab-pane>
            <el-tab-pane label="岗位晋升" name="promotion"></el-tab-pane>
            <el-tab-pane label="招聘岗位" name="requirement"></el-tab-pane>
            <el-tab-pane label="加入我们" name="joinUs"></el-tab-pane>
          </el-tabs>
        </div>
        <div>
          <div id="process">
            <h1>招聘流程</h1>
            <p style="letter-spacing: 0;">来吧，加入我们！</p>
            <p style="letter-spacing: 0;">
              我们是一群快乐、简单做事情的年轻人，我们喜欢接受新生事物、喜欢迎接挑战、追求新鲜、时尚，我们愿意为提升个人能力和推动企业发展付诸行动！
            </p>
            <p style="letter-spacing: 0;">
              在这里，你将会得到持续成长的环境和空间，持续提升的个人素质和技能，持续展现自我价值和人生梦想！
            </p>
            <br />
            <div
              style="margin-right:16px;vertical-align: top;width:60px;height:60px;border:1px solid rgba(202,220,234,1);border-radius:50%;"
            >
              <div style="margin:12px 15px;width:30px;line-height:18px;">
                面试流程
              </div>
            </div>
            <img src="../assets/job/longArrow.png" />
            <div><img src="../assets/job/step0.png" /> <br />发送简历</div>
            <img src="../assets/job/longArrow.png" />
            <div><img src="../assets/job/step1.png" /> <br />简历筛选</div>
            <img src="../assets/job/longArrow.png" />
            <div><img src="../assets/job/step2.png" /> <br />专业面试</div>
            <img src="../assets/job/longArrow.png" />
            <div><img src="../assets/job/step3.png" /> <br />HR资格面试</div>
            <img src="../assets/job/longArrow.png" />
            <div><img src="../assets/job/step4.png" /> <br />背景调查</div>
            <img src="../assets/job/longArrow.png" />
            <div><img src="../assets/job/step5.png" /> <br />发放OFFER</div>
          </div>
          <hr />
          <div id="compensation">
            <h1>薪酬福利</h1>
            <div class="mt__content--table">
              <div class="mt__content--main">
                <div>
                  <img src="../assets/job/compensation0.png" />
                  <h3>调薪机制</h3>
                  <span>实行季度调薪机制（一年有2次调薪机会）。</span>
                </div>
                <div>
                  <img src="../assets/job/compensation1.png" />
                  <h3>绩效奖金</h3>
                  <span>奖金获得具体根据工作表现及公司业绩而定。</span>
                </div>
                <div>
                  <img src="../assets/job/compensation2.png" />
                  <h3>基础保障</h3>
                  <span>周末双休，六险一金，法定带薪假及年假，年度体检。</span>
                </div>
              </div>
              <div class="mt__content--main">
                <div>
                  <img src="../assets/job/compensation3.png" />
                  <h3>落户深圳</h3>
                  <span
                    >公司可协助办理深圳户口，落户深圳后可享受深圳市政府提供的人才租房和生活补贴，本科1.5万，硕士2.5万，博士3万。</span
                  >
                </div>
                <div>
                  <img src="../assets/job/compensation4.png" />
                  <h3>股份期权</h3>
                  <span
                    >公司为高绩效高潜力且有志于在公司长期发展的核心员工提供股权激励。</span
                  >
                </div>
                <div>
                  <img src="../assets/job/compensation5.png" />
                  <h3>团建娱乐</h3>
                  <span
                    >组织开展丰富多彩的文化娱乐活动，如：团队旅游、年终晚会、篮球协会/比赛、羽毛球协会/比赛、足球协会/比赛等。</span
                  >
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div id="promotion">
            <h1>岗位晋升</h1>
            <p>1. 技术发展通道：</p>
            <el-button size="small" type="primary" round>初级工程师</el-button>
            <img src="../assets/job/arrow.png" />
            <el-button size="small" type="primary" round>中级工程师</el-button>
            <img src="../assets/job/arrow.png" />
            <el-button size="small" type="primary" round>高级工程师</el-button>
            <img src="../assets/job/arrow.png" />
            <el-button size="small" type="primary" round>系统架构师</el-button>
            <img src="../assets/job/arrow.png" />
            <el-button size="small" type="primary" round>技术总监</el-button>
            <p style="margin-top:40px;">2. 管理发展通道：</p>
            <div class="mt__content--main">
              <div style="vertical-align: middle;">
                <el-button type="primary" round>初级工程师</el-button>
                <img src="../assets/job/arrow.png" />
                <el-button type="primary" round>中级工程师</el-button>
                <img src="../assets/job/arrow.png" />
                <el-button type="primary" round>高级工程师</el-button>
              </div>

              <div>
                <div style="margin-bottom: 14px;">
                  <img src="../assets/job/arrow.png" />
                  <el-button size="small" type="primary" round
                    >项目经理</el-button
                  >
                  <img src="../assets/job/arrow.png" />
                  <el-button size="small" type="primary" round
                    >产品经理</el-button
                  >
                  <img src="../assets/job/arrow.png" />
                  <el-button size="small" type="primary" round
                    >产品总监</el-button
                  >
                </div>

                <div style="margin-top: 14px;">
                  <img src="../assets/job/arrow.png" />
                  <el-button size="small" type="primary" round
                    >研发组长</el-button
                  >
                  <img src="../assets/job/arrow.png" />
                  <el-button size="small" type="primary" round
                    >研发经理</el-button
                  >
                  <img src="../assets/job/arrow.png" />
                  <el-button size="small" type="primary" round
                    >研发总监</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div id="requirement">
            <h1>招聘岗位</h1>
            <span>工作地点:</span>
            <div
              class="mt__button"
              v-for="(value, key) in citys"
              :key="key"
              @click="toggleCity(key)"
              :class="{ 'mt__button--active': value }"
            >
              {{ key }}
            </div>
            <br />
            <br />
            <el-table
              ref="jobTable"
              :data="searchTableData"
              @row-click="expand"
              style="width: 100%"
            >
              <el-table-column prop="标题" label="职位名称"></el-table-column>
              <el-table-column
                prop="工作地点"
                label="工作地点"
              ></el-table-column>
              <el-table-column
                prop="发布时间"
                label="发布时间"
              ></el-table-column>
              <el-table-column type="expand">
                <template slot-scope="props">
                  <div v-html="props.row['内容']"></div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <hr />
          <div id="joinUs">
            <h1>加入我们</h1>
            <!-- <div class="mt__content--right" style="overflow: hidden;">
              <iframe
                style="margin: -31px -3px -38px -1px;"
                width="484"
                height="335"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                src="http://j.map.baidu.com/s/LS4IFb"
              ></iframe>
            </div> -->
            <iframe
              title="公司地址"
              class="mt__content--right"
              width="480"
              height="270"
              frameborder="0"
              src="https://f.amap.com/4GPiC_0436fMN"
            ></iframe>
            <p style="line-height:30px;">
              联系人：&emsp;熊小姐
              <br />联系电话：0755-86004500
              <br />联系邮箱：hr@mastercom.cn
              <br />公司地址：深圳市南山区科技园科发路8号金融基地2栋10楼A/B区
            </p>
            <img src="../assets/job/Bitmap.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tabs from "./tabs.vue";
export default {
  extends: tabs,
  name: "job",
  data() {
    return {
      tabName: "job",
      scrollTop: {
        process: 0,
        compensation: 0,
        promotion: 0,
        requirement: 0,
        joinUs: 0
      },

      citys: {},
      tableData: [],
      searchTableData: []
    };
  },
  created() {},
  mounted() {
    let that = this;
    let tableData = this.tableData;
    let citys = this.citys;
    this.$http
      .post("/mtex/mtplat/portal/queryJobs")
      .then(function(response) {
        for (const job of response.data.result.data) {
          job["发布时间"] = job["发布时间"].split(" ")[0];
          tableData.push(job);
          for (const city of job["工作地点"].split(",")) {
            that.$set(citys, city, false);
          }
        }
        for (const city in citys) {
          that.$set(citys, city, true);
          break;
        }
        that.jobData();
      })
      .catch(function(err) {
        console.log(err);
      });
  },
  updated() {},
  methods: {
    toggleCity(city) {
      for (const key in this.citys) {
        this.citys[key] = false;
      }
      this.citys[city] = true;
      this.jobData();
    },
    jobData() {
      let searchData = [];
      for (const iterator of this.tableData) {
        for (const city of iterator["工作地点"].split(",")) {
          if (this.citys[city]) {
            searchData.push(iterator);
          }
        }
      }
      this.searchTableData = searchData;
    },
    expand(row, event, column) {
      this.$refs.jobTable.toggleRowExpansion(row);
    }
  }
};
</script>
<style scoped>
.mt__banner {
  background-image: url("../assets/job/carousel0.png");
}

.mt__content--table > .mt__content--main > * {
  padding: 40px 50px 20px 0;
}
/* .el-table__row td {
  cursor: pointer;
} */

#process > div {
  display: inline-block;
  width: 78px;
  margin: 0 5px;

  text-align: center;
  color: #1f5c99;
  font-size: 14px;
}
#process > img {
  vertical-align: top;
  margin-top: 22px;
}
#process > div > img {
  margin-bottom: 11px;
}

#promotion img {
  margin: 0 7px;
  vertical-align: middle;
}
.mt__button {
  display: inline-block;
  cursor: pointer;
  padding: 0 12px;

  font-size: 14px;
  color: #333333;
  line-height: 24px;
  text-align: center;

  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.mt__button--active {
  background: #cee9fc;
  border-radius: 2px;
}

span {
  color: #4d4d4d;
}
/* .mt__button:hover {
  background: rgba(12, 143, 242, 1);

  color: rgba(255, 255, 255, 1);
}
.mt__button:active {
  opacity: 0.8;
} */
</style>



// WEBPACK FOOTER //
// src/components/job.vue